import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { AssetApi } from '../../shared/api/asset.api';
import { AssetById, QROptions, UpdateAsset } from 'app/shared/models/assets.models';
import { IdName } from 'app/shared/models/standard.models';

@Component({
  selector: 'asset-card',
  templateUrl: './asset-card.component.html',
  styleUrls: ['./asset-card.component.css']
})
export class AssetCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() assetId: string;

  api = new AssetApi(this.http)
  asset: AssetById;
  companyInfo;
  lists = new AssetCardLists();
  subscriptions = new AssetCardSubscriptions();
  qrOptions = new QROptions();
  serialNumber;
  serialNumberInvalid = false;
  serialNumberAdded = false;
  responseMessage;
  loading = false;
  warrantyDate:Date | null = null;
  constructor(private http: HttpClient, private sharedData: SharedDataService) { }

  ngOnInit(): void {
    this.subscriptions.companyInformation = this.sharedData.companyInformation().subscribe((data) => this.companyInfo = data);
    this.subscriptions.categories = this.sharedData.assetCategories().subscribe((data) => { this.lists.categories = data; });
    this.subscriptions.skills = this.sharedData.skills().subscribe((data) => { this.lists.skills = data; });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.assetId && !!changes.assetId.currentValue) {
      this.loadAsset();
    }
  }

  ngOnDestroy(): void {
    for (let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  loadAsset() {
    this.api.assetById(this.assetId).subscribe((data: AssetById) => {
      if (!!data.customFields) data.customFields = data.customFields.map(x => { return { ...x, type: x.typeId, template: !!x.template && typeof (x.template) == 'string' ? x.template.split(';') : null } })
      this.asset = data;
      if(!!data.warrantyDate) this.warrantyDate = new Date(data.warrantyDate);
    })
  }

  changeDate(date) {
    this.asset.warrantyDate = date.toISOString();
    this.saveAsset();
  }

  saveAsset() {
    //console.log(this.asset)
    let data: UpdateAsset = {
      modelName: this.asset.modelName,
      serialNumber: this.asset.serialNumber,
      warrantyDate: this.asset.warrantyDate,
      address: this.asset.address,
      zipCode: this.asset.zipCode,
      city: this.asset.city,
      remark: this.asset.remark,
      customerOwnerId: null,
      companyOwnerId: null,
      installationContractor: this.asset.installationContractor.id,
      labelId: this.asset.labelId,
      serviceOwner: this.asset.serviceOwner.id,
      categoryId: this.asset.category.id,
      skillId: this.asset.skill.id,
      customerFields: [],
      contactName: this.asset.contactName,
      contactEmail: this.asset.contactEmail,
      contactPhone: this.asset.contactPhone,
      year: this.asset.year
    }
    //console.log(data);
    this.api.updateAsset(this.assetId, data).subscribe(
      () => { }
    )
  }

  addSerialNumber() {
    this.loading = true;
    let response: number;
    this.api.addSerialNumber(this.assetId, this.serialNumber).subscribe(
      result => {
        response = result.status;
        //console.log(result);
      },
      response => {
        //console.log('response: ', response);
        if (response.status != 200) {
          this.responseMessage = response.error;
          this.serialNumberInvalid = true;
          this.loading = false;
        } else {
          this.serialNumberInvalid = false;
          this.loading = false;
          this.serialNumberAdded = true;
        }
      },
      () => {
        //console.log(response);
        if (response == 200) {
          this.serialNumberInvalid = false;
          this.loading = false;
          this.serialNumberAdded = true;
        } else {
          console.log('error');
          this.loading = false;
          this.serialNumberInvalid = true;
        }
      });
  }
}

class AssetCardSubscriptions {
  skills: any;
  categories: Subscription;
  routeParams;
  companyInformation: Subscription;
}

class AssetCardLists {
  skills: any[];
  categories: IdName[];
}